import React from "react";
import { useNavigate } from "react-router-dom";
import { useStream } from "@/lib/useStream";
import { Radio, Zap, Wallet, Rocket, Droplets, Bell } from "lucide-react";

const ICONS = {
  opportunity: Zap,
  wallet_buy: Wallet,
  dev_launch: Rocket,
  liquidity: Droplets,
  alert: Bell,
};

export default function LiveActivityStrip() {
  const { events, connected } = useStream(20);
  const nav = useNavigate();

  return (
    <div className="pnut-card mb-5 overflow-hidden" data-testid="live-activity-strip">
      <div className="flex items-center gap-2 border-b border-slate-800/70 px-4 py-2">
        <span className={`live-dot ${connected ? "" : "!bg-slate-600"}`} style={connected ? {} : { animation: "none" }} />
        <span className="font-display text-xs font-semibold uppercase tracking-wide text-slate-200">Live Activity</span>
        <span className="ml-1 font-mono text-[10px] text-slate-500">
          {connected ? "streaming · websocket" : "reconnecting…"}
        </span>
        <span className="ml-auto rounded border border-slate-800 px-1.5 py-0.5 font-mono text-[9px] text-slate-500">REAL-TIME</span>
      </div>
      <div className="max-h-40 overflow-y-auto">
        {events.length === 0 ? (
          <div className="px-4 py-4 text-center text-xs text-slate-600">Waiting for live events…</div>
        ) : (
          events.map((ev) => {
            const Icon = ICONS[ev.kind] || Zap;
            return (
              <button
                key={ev.id}
                onClick={() => ev.token_id && nav(`/token/${ev.token_id}`)}
                className="fade-in flex w-full items-center gap-3 border-b border-slate-800/40 px-4 py-2 text-left hover:bg-amber-500/5"
              >
                <Icon className={`h-3.5 w-3.5 shrink-0 ${ev.severity === "high" ? "text-amber-400" : "text-slate-500"}`} />
                <span className="flex-1 truncate text-xs text-slate-300">{ev.title}</span>
                {ev.live && <span className="rounded border border-emerald-800/50 px-1 py-0.5 font-mono text-[8px] text-emerald-400">LIVE</span>}
                <span className="shrink-0 font-mono text-[9px] text-slate-600">now</span>
              </button>
            );
          })
        )}
      </div>
    </div>
  );
}
